import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-box3-schulden',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-box3-schulden.component.html',
  styleUrl: './tekst-box3-schulden.component.scss',
})
export class TekstBox3SchuldenComponent implements OnInit {

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();

  public drempel = 0;


  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
      if (this.year == 2024) {
          this.drempel = 3200
      }
    })
  }

}
